import script from "./ContentsArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentsArea.vue?vue&type=script&setup=true&lang=ts"

import "./ContentsArea.vue?vue&type=style&index=0&id=40fce184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fce184"]])

export default __exports__